<template>
  <span class="cicle-pointer">
    <slot />
  </span>
</template>

<script>
export default {}
</script>
<style lang="less">
.cicle-pointer {
  display: inline-block;
  padding: 4px 4px;
  line-height: 12px;
  border-radius: 2px;
  background: #60acfc;
  font-size: 12px;
  text-align: center;
  color: #fff;
}
</style>
